import React from 'react';

import { cn } from '@pray/shared/utils/styles';

import type { CheckoutPricingProps } from '../types';

import styles from './CheckoutPricing.module.scss';

export default function CheckoutPricing({ children, className }: CheckoutPricingProps) {
  return <div className={cn(styles.pricing, className)}>{children}</div>;
}
